// Shared file-size guard for image uploads (COL-96). Enforced identically
// wherever a user can start an image upload — drag/drop, the file picker,
// and paste — so the same file behaves the same way regardless of entry
// point, instead of paste silently applying a stricter rule than Upload.
//
// No backend limit exists at this layer (image_processor only *downscales*
// on the way out), so this is purely a client-side UX guard against a
// paste/drop that would otherwise sit "uploading" for a very long time with
// no feedback. Generous enough for a real screenshot or photo.
export const MAX_UPLOAD_IMAGE_BYTES = 20 * 1024 * 1024; // 20MB
